import Decimal from 'decimal.js';

export function getTotalPrice(pricePerUnit: number, quantity: number) {
  const price = new Decimal(pricePerUnit);
  const totalPrice = price.times(quantity);

  return totalPrice.toNumber();
}
